import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { EmailValidator } from "@cervval.js/common/src/services/validation.impl/validators/email.validator";
import { RequiredValidator } from "@cervval.js/common/src/services/validation.impl/validators/required.validator";
import { validatorEntry } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { BookingUser } from "../booking.dto";
import { I18nProfileBooking } from "./profileBooking.i18n";

export const sortedMailDTOKeys: (keyof BookingUser)[] = ["email"];

/** Export BookingUser as PropertyConfig */
export function exportBookingMailDTOToPropertyConfig(): PropertyConfig[] {
    const i18n = I18nProfileBooking();
    const propertyConfigs: PropertyConfig[] = [];
    sortedMailDTOKeys.forEach((key) => {
        let propertyConfig = {} as PropertyConfig;
        const comp = propertyConfig;
        switch (key) {
            case "email":
                propertyConfig = {
                    label: i18n.email.label,
                    propertyName: key,
                    typeUid: PropertyConfigType.EMAIL,
                    options: {
                        placeholder: i18n.email.optionsPlaceholder,
                        disabled: true
                    },
                    validators: {
                        ...validatorEntry(RequiredValidator, true),
                        ...validatorEntry(EmailValidator, true)
                    }
                };
                break;
            default:
                break;
        }
        if (propertyConfig !== comp) {
            propertyConfigs.push(propertyConfig);
        }
    });
    return propertyConfigs;
}